import * as types from 'constants/ActionTypes';
import { PATH } from 'constants/RoutesConstants';
import { FETCH_APPOINTMENT_SUCCESS } from 'modules/appointments/actionTypes';
import { FETCH_VAULT_SUCCESS } from 'modules/lockers/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = null;

/**
 * @param {string|null} _
 * @param {import('modules/dealers/types').SelectDealerAction} action
 * @returns {string}
 */
const selectDealerReducer = (_, { payload }) => payload.dealerId;

const selectDealerByVaultReducer = (state, { payload }) => payload?.dealerId ?? payload?.dealer?.id ?? state;

const selectDealerByAppointment = (_, { payload }) => payload?.dealerId ?? payload.dealer.id;

/**
 *
 * @param {import('modules/dealers/_types/types').DEALER} _
 * @param {import('modules/dealers/types').CreateDealerSuccessAction} action
 * @returns {string}
 */
const selectDealerAfterCreateNewOne = (_, { payload: dealer }) => dealer.id;

const onErrorRedirection = (state, { payload }) => (payload.location.pathname === PATH.ERROR_404.path ? null : state);

export default createReducer(initialState, {
  [LOCATION_CHANGE]: onErrorRedirection,
  [types.SELECT_DEALER]: selectDealerReducer,
  [FETCH_VAULT_SUCCESS]: selectDealerByVaultReducer,
  [FETCH_APPOINTMENT_SUCCESS]: selectDealerByAppointment,
  [types.CREATE_DEALER_SUCCESS]: selectDealerAfterCreateNewOne,
});
